import { render, staticRenderFns } from "./MarkdownViewer.vue?vue&type=template&id=707448ed&scoped=true&"
import script from "./MarkdownViewer.vue?vue&type=script&lang=ts&"
export * from "./MarkdownViewer.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownViewer.vue?vue&type=style&index=0&id=707448ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707448ed",
  null
  
)

export default component.exports